export const REPLACE_RESOURCES = 'REPLACE_RESOURCES';
export const ADD_RESOURCE = 'ADD_RESOURCE';
export const UPDATE_RESOURCE = 'UPDATE_RESOURCE';